import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { LigneBudgetService } from '@service/syndic/ligne-budget.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-ligne-budget-add',
  templateUrl: './ligne-budget-add.component.html',
  styleUrls: ['./ligne-budget-add.component.scss']
})
export class LigneBudgetAddComponent implements OnInit {
  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  ligneBudget: any;
  title: string = '';
  budgetUuid: string = '';

  types = [
    { label: 'Dépense', value: 'DEPENSE' },
    { label: 'Recette', value: 'RECETTE' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private ligneBudgetService: LigneBudgetService,
    private syndicService: SyndicService
  ) {
    this.edit = this.ligneBudgetService.edit;
    this.ligneBudget = this.ligneBudgetService.getLigneBudget();
    this.budgetUuid = this.ligneBudgetService.budgetUuid || '';
    const lib = this.ligneBudget ? this.ligneBudget.libelle : '';
    this.title = (!this.edit) ? 'Ajouter une ligne de budget' : 'Modifier la ligne ' + lib;
  }

  ngOnInit(): void {
    this.createForm();
    if (this.edit && this.ligneBudget) { this.setFormValue(); }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      libelle: [null, [Validators.required]],
      compteOHADA: [null],
      montant: [0, [Validators.required]],
      type: ['DEPENSE', [Validators.required]],
      categorie: [null],
      sousCategorie: [null],
      estRecuperable: [false],
      montantRealise: [0],
      description: [null],
      budget: [this.budgetUuid, [Validators.required]],
      trustee: [this.syndicService.getSyndic()?.uuid, [Validators.required]]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.ligneBudget.uuid,
      libelle: this.ligneBudget.libelle,
      compteOHADA: this.ligneBudget.compteOHADA,
      montant: this.ligneBudget.montant,
      type: this.ligneBudget.type,
      categorie: this.ligneBudget.categorie,
      sousCategorie: this.ligneBudget.sousCategorie,
      estRecuperable: this.ligneBudget.estRecuperable,
      montantRealise: this.ligneBudget.montantRealise,
      description: this.ligneBudget.description,
      budget: this.ligneBudget.budget?.uuid,
      trustee: this.ligneBudget.trustee?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.ligneBudgetService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'LIGNE_BUDGET_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'LIGNE_BUDGET_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void { this.modal.close('ferme'); }
  get f() { return this.form.controls; }
}
